module.exports = "/img/_/_/_/assets/images/creeper/book/rare//14.jpg?9fd5893a24f363bba5ca7a9a5b58b6d5";